// Types and helpers for Automatic Contracting credits (buying and showing the balance).

export interface CreditPackage {
  key: string;
  label: string;
  credits: number;
  price_cents: number;
  quantity_allowed: boolean;
  max_quantity?: number;
}

export interface CreditHistoryItem {
  id: string;
  kind: 'starter' | 'purchase' | 'usage' | 'admin_grant' | 'refund';
  amount: number;
  balance_after: number;
  note: string | null;
  created_at: string;
}

export interface CreditsInfo {
  balance: number;
  packages: CreditPackage[];
  starter_credits: number;
  support_email: string;
  history: CreditHistoryItem[];
}

export const formatCents = (cents: number): string =>
  `$${(cents / 100).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;

// What one use costs inside a package, e.g. "$0.75 per use".
export const perUseLabel = (credits: number, priceCents: number): string =>
  `${formatCents(priceCents / credits)} per use`;

// Price of a package for a chosen quantity (only single uses can change quantity).
export const packagePrice = (pkg: CreditPackage, quantity: number): number =>
  pkg.quantity_allowed ? pkg.price_cents * quantity : pkg.price_cents;

export const clampQuantity = (value: number, max = 99): number =>
  Number.isFinite(value) ? Math.min(Math.max(Math.trunc(value), 1), max) : 1;
